import { iso3166 } from 'iso3166';


const getCountryName = (code: string) => {
    const country = iso3166[code];
    return country?.name || code;
}

export { getCountryName };
